import { getMarket, getTags } from './helpers';
import { getTagsByProcess } from './tags';
import Logger from '../logger';

const changeNameCasing = (name, customerType) => {
    if (customerType && customerType === 'INDIVIDUAL') {
        if (!name) return name;
        name = name.toLocaleLowerCase();
        return name.charAt(0).toLocaleUpperCase() + name.slice(1);
    }
    return name;
};

const castTags = (tagsObject) => {
    if (Array.isArray(tagsObject)) {
        return tagsObject;
    } else if (typeof tagsObject === 'string') {
        return tagsObject.split(',');
    } else {
        return [];
    }
};

const decodeAdditionalData = (additionalData) => {
    try {
        if (typeof additionalData === 'string') {
            return JSON.parse(atob(additionalData));
        } else {
            return additionalData;
        }
    } catch (error) {
        Logger.error('while decoding additionalData:', error);
        return additionalData;
    }
};

const addAdditionalData = (args) => {
    if (!args.verMO) {
        return;
    }

    const flatArguments = ['contextInvoiceId'];
    flatArguments.forEach((fa) => {
        if (fa in args) {
            args.additionalData = {
                ...(args.additionalData && {
                    ...args.additionalData
                }),
                [fa]: args[fa]
            };
        }
    });
};

const getSupportData = (args) => {
    args.tags = castTags(args.tags);
    args.additionalData = decodeAdditionalData(args.additionalData);
    const market = getMarket(args);
    const tags = getTags(
        args.tags,
        getTagsByProcess('Support'),
        market,
        args.verMO ? true : false,
        args.loginType ? args.loginType : 'none'
    );
    const syneriseUUID = window.WC._cookies.getCookie('_snrs_uuid');
    if (!syneriseUUID) {
        Logger.log('no _snrs_uuid');
    }
    addAdditionalData(args);
    return {
        ...(tags && {
            tags: tags
        }),
        additionalData: {
            rynek: market,
            ...(syneriseUUID && { _snrs_uuid: syneriseUUID }),
            ...(args.client_type && { 'typ klienta': args.client_type }),
            ...(args.analyticsViewName && { analyticsViewName: args.analyticsViewName }),
            ...(args.name && {
                name: changeNameCasing(args.name, args.customerType)
            }),
            ...(args.additionalData && {
                ...args.additionalData
            }),
            ...(args.webViewUrl && { webViewUrl: args.webViewUrl })
        }
    };
};

export default getSupportData;
